'use strict';

let CreditCardDefaults = {
  CountryOfIssuance: 'USA',
  IssuingBank: 'NETWORK ONLY'
};

module.exports = {CreditCardDefaults: CreditCardDefaults};
